import { StringUtils } from "../../../../utils/stringUtils";
import { ReportProps, ValidationError, Validator } from "../../../../types/types";

export class ReportGlobalFilterValidator implements Validator<ReportProps> {
    validate(props: ReportProps): ValidationError[] {
        const errors: ValidationError[] = [];
        if (props.showReport) {
            const info = props.reportUI
            const viewMode = props.reportInfo.viewEditStatus === 'VIEW' ? true : false
            if (StringUtils.isEmpty(info.role) && !viewMode)
                errors.push(new ValidationError("roleError", "Please select role!"))
            else if (StringUtils.isEmpty(info.type) && !viewMode)
                errors.push(new ValidationError("typeError", "Please select type!."))
            else if (StringUtils.isEmpty(info.label) && !viewMode)
                errors.push(new ValidationError("labelError", "Please provide meaningful label!."))
        }
        return errors;
    }
}